import React from 'react';
import Hero from '@/components/home/Hero/Hero';
import Services from '@/components/home/Services/Services';
import Projects from '@/components/home/Projects/Projects';
import Testimonials from '@/components/home/Testimonials/Testimonials';
import PricingTeaser from '@/components/home/PricingTeaser/PricingTeaser';
import BlogTeaser from '@/components/home/BlogTeaser/BlogTeaser';
import ContactStrip from '@/components/home/ContactStrip/ContactStrip';

const Home: React.FC = () => {
  return (
    <div>
      <Hero />
      <Services />
      <Projects />
      <Testimonials />
      <PricingTeaser />
      <BlogTeaser />
      <ContactStrip />
    </div>
  );
};

export default Home;
